import { render, staticRenderFns } from "./villageedit.vue?vue&type=template&id=4a0fdeba&scoped=true&"
import script from "./villageedit.vue?vue&type=script&lang=js&"
export * from "./villageedit.vue?vue&type=script&lang=js&"
import style0 from "./villageedit.vue?vue&type=style&index=0&id=4a0fdeba&lang=stylus&scoped=true&"
import style1 from "./villageedit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0fdeba",
  null
  
)

component.options.__file = "villageedit.vue"
export default component.exports